import { Container } from "./TabPanel.styles";

export function TabPanel({ value, index, children }) {
  if (value !== index) {
    return null;
  }

  return <Container>{children}</Container>;
}
